import { Routes } from '@angular/router';

export const LANGUAGE_ROUTES: Routes = [
  {
    path: 'channels/languages/view-edit/:languageId',
    loadComponent: () =>
      import('./language-view-edit/language-view-edit.component').then(
        (com) => com.LanguageViewEditComponent
      ),
    title: 'View/Edit Language',
  },
  {
    path: 'channels/languages/add',
    loadComponent: () =>
      import('./language-add/language-add.component').then(
        (com) => com.LanguageAddComponent
      ),
    title: 'Add Language',
  },
];
